package uk.co.nickthecoder.kyd

/**
 * A reference to another resource (similar to symbolic links in *nix filesystems).
 *
 * Suppose we have a game with monsters, let's suppose we have [Role]s "/monsters/big" and "/monsters/bad".
 * Occasionally, they growl, so we put a sound in each called "growl" (e.g. "/monsters/big/growl").
 * Now suppose we create a new monster "/monsters/ugly". Its appearance is different, but its growl is the same as "bad's"..
 * Instead of creating another copy, we create a [Link] (/monsters/ugly/growl) which points to "/monsters/bad/growl".
 *
 * We will have a [Behaviour] for _all_ monsters, which can find the appropriate sound like so :
 *
 *     val growl = actor.role!!.find( "growl" ) as Sound
 *
 * I often use links. YMMV.
 */
class Link(

    parent: ParentResource,
    name: String,
) : AbstractParentResource(parent, name), ResolvableResource {

    var linkToPath: String = ""
        set(v) {
            field = v
            resolveReferences()
        }

    var linkedResource: Resource? = null
        get() {
            if (field == null) {
                resolveReferences()
            }
            return field
        }
        private set

    override val resourceType: ResourceType
        get() = ResourceType.LINK


    override fun resolveReferences(): String? {
        if (linkToPath.isEmpty()) return null
        val result = find(linkToPath)
        if (result == null) {
            return "Link '$linkToPath' not found"
        } else {
            linkedResource = result
        }
        return null
    }

}
